import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Logger } from '@eng-dx-gpt/logger';
import { finalize } from 'rxjs';

export const loggerInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const started = Date.now();
    const logger = inject(Logger);
    return next(req).pipe(
        finalize(() => {
            const elapsed = Date.now() - started;
            logger.info(`URL: ${req.url} Method: ${req.method} Time took: ${elapsed} ms`);
        })
    );
};
